// Angular Files
import { Component, computed, Signal } from '@angular/core';
import { isActive, IsActiveMatchOptions, Router } from '@angular/router';

// Teller Online Library Files
import {
    TellerOnlineRailNavigationElement,
    TellerOnlineRailNavigationService
} from '../../services/rail-navigation.service';

// Same as routerLinkActive's `exact: true`
const EXACT_MATCH: Partial<IsActiveMatchOptions> = { paths: 'exact', queryParams: 'exact' };

// The link's own page, whatever its query string
const PAGE_MATCH: Partial<IsActiveMatchOptions> = { paths: 'exact', queryParams: 'ignored' };

@Component({
    selector: 'app-rail-navigation',
    templateUrl: './rail-navigation.component.html',
    styleUrls: ['./rail-navigation.component.scss'],
    host: {
        class: 'rail-navigation'
    },
    standalone: false
})
export class TellerOnlineRailNavigationComponent {
    // Public Variables
    // The active entries and their aria-current: 'page' on the link's own page, 'true' on another
    // page the entry owns, where the user is in its section rather than on it. Worked out here
    // rather than per link with routerLinkActive, which only knows the link's own url.
    public readonly currentStates: Signal<Map<TellerOnlineRailNavigationElement, 'page' | 'true'>>;

    constructor(
        private router: Router,
        public railNavigationService: TellerOnlineRailNavigationService
    ) {
        const matches = computed(() => this.railNavigationService.elements().map(element => ({
            element,
            page: element.disabled ? null : isActive(element.link, this.router, PAGE_MATCH),
            active: element.disabled ? [] : [
                isActive(element.link, this.router, element.exactMatch ? EXACT_MATCH : {}),
                ...(element.alsoActiveOn ?? []).map(path => isActive(path, this.router))
            ]
        })));

        this.currentStates = computed(() => new Map(matches()
            .filter(match => match.active.some(active => active()))
            .map(match => [match.element, match.page?.() ? 'page' : 'true'] as const)));
    }
}
